<template>
  <div class="paper-page-container">
    <exam-header :canClickLogo="true"></exam-header>
    <div class="page-content">
      <div class="page-content-head">
        <div class="page-title-warp">
          <div class="back" @click="goBack"><i class="el-icon-arrow-left"></i>返回</div>
          <div class="title"><i></i>交叉批改规则管理</div>
        </div>
        <div class="filter-section">
          <el-form :model="filterForm" :inline="true" class="filter-form">
            <el-form-item label="业务类型：">
              <el-select v-model="filterForm.level" placeholder="请选择" class="form-select-width" @change="updateUrlParams">
                <el-option :label="item.label" :value="item.id" v-for="(item,index) in EXAM_LEVEL_TYPE" :key="index" />
              </el-select>
            </el-form-item>
            <el-form-item label="考试名称：">
              <el-select
                  v-model="filterForm.roundId"
                  placeholder="请输入"
                  class="teacher-paper-select select-round"
                  filterable
                  :loading="roundsLoading"
              >
                <el-option label="全部" value="" />
                <el-option :label="item.roundName" :value="item.id" v-for="item in examRoundList" :key="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="规则是否确认：">
              <el-select
                  v-model="filterForm.markModeStatus"
                  placeholder="请选择"
                  clearable>
                <el-option :value="1" label="是">是</el-option>
                <el-option :value="0" label="否">否</el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="form-btns">
            <el-button type="primary" @click="handleQuery" class="search-btn">查询</el-button>
            <el-button @click="handleReset" class="reset-btn">重置</el-button>
          </div>
        </div>
      </div>
      <div class="page-content-body" v-if="listLoading|| (listData && listData.length)">
        <p class="page-tips"><span/>请仔细确认交叉批改规则，规则确认后，立即生效</p>
        <div class="table-section">
          <el-table
            :data="listData"
            :loading="listLoading"
            stripe
            style="width: 100%">
            <el-table-column
              prop="roundName"
              align="left"
              label="考试名称"
              min-width="180"
              >
            </el-table-column>
            <el-table-column
              label="参与学校"
              align="center"
              min-width="200"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.schools && scope.row.schools.length > 0">
                  {{ scope.row.schools.map(school => school.schoolName).join(' | ') }}
                </span>
                <span v-else>所有学校</span>
              </template>
            </el-table-column>
            <el-table-column
              label="考试开始时间"
              align="center"
              min-width="180">
              <template slot-scope="scope">
                {{ scope.row.startTime |  formatTime}}
              </template>
            </el-table-column>
            <el-table-column
              label="考试结束时间"
              align="center"
              min-width="180">
              <template slot-scope="scope">
                {{ calculateEndTime(scope.row)}}
              </template>
            </el-table-column>
            <el-table-column
              label="当前考试进度"
              align="center"
              min-width="140">
              <template slot-scope="scope">
                <span class="progress-status" :class="examProgress(scope.row).class">
                  <i class="status-dot"></i>
                  {{ examProgress(scope.row).text }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="规则是否确认"
              align="center"
              min-width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.roundMark.status === 1" class="confirm-status confirmed">
                  <i class="el-icon-success"></i>
                </span>
                <span v-else class="confirm-status unconfirmed">
                  <i class="el-icon-warning"></i>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="confirmUsername"
              label="规则确认人"
              align="center"
              min-width="120"
              show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row?.roundMark?.confirmUsername || '-' }}
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                width="120"
              label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.roundMark?.status === 0"
                  @click="handleEdit(scope.row,'edit')"
                  :class="['action-btn']">
                  <i class="el-icon-edit"></i>编辑
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.roundMark?.status === 1"
                  @click="handleEdit(scope.row,'preview')"
                  :class="['action-btn']">
                  <i class="el-icon-view"></i>查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-section">
          <div class="pagination-info">
            总共<span>{{ pagination.total }}</span>个项目
          </div>
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.pageNo"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagination.pageSize"
              :total="pagination.total"
              layout="prev, pager, next, jumper">
          </el-pagination>
        </div>
      </div>
      <div class="page-content-body" v-else>
        <empty-page text="暂时没有需要配置规则的考试">
          <button slot="content" class="back-btn" @click="goBack">返回</button>
        </empty-page>
      </div>
    </div>

    <!-- 批改规则详情弹窗 -->
    <mark-rule-detail-modal
      v-if="markDetailModal"
      :exam-info="currentExamInfo"
      :round-mark="roundMark"
      :school-list="schoolList"
      :is-edit-mode="isEditMode"
      :level="filterForm.level"
      @close="handleModalClose"
      @save="handleSaveRule"
      @cancel="handleModalClose">
    </mark-rule-detail-modal>
    <page-footer></page-footer>
  </div>
</template>

<script>
import ExamHeader from "./components/teacherExamHeader.vue";
import PageFooter from '@/components/PageFooter.vue';
import MarkRuleDetailModal from "./components/markRuleDetailModal.vue";
import {Button , Form, FormItem, Input, Option, Pagination, Select, Table, TableColumn} from 'element-ui';
import {getExamMarkRelationList, getExamRounds, getMarkRelationDetail, getUserSchools} from "@/api/qzTeacher";
import EmptyPage from './components/emptyPage.vue';
import dayjs from "dayjs";
import {getSystemTimeSync} from "@/api/api";
import { EXAM_LEVEL_TYPE } from '@/common/constant/qz';


export default {
  components: {
   "empty-page":EmptyPage,
   'el-button':Button,
    'el-select': Select,
    'el-option': Option,
    'exam-header':ExamHeader,
    'mark-rule-detail-modal': MarkRuleDetailModal,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-pagination': Pagination,
    PageFooter,
  },
  filters: {
    formatTime(time) {
      return time ? dayjs(time).format('YYYY.MM.DD HH:mm:ss') : '';
    }
  },
  data() {
    return  {
      EXAM_LEVEL_TYPE,
      filterForm:{
        level: 'MATHS_TALENTS_1',
        roundId:'',
        markModeStatus:''
      },
      // 分页数据
      pagination:{
        total: 0,
        pageNo: 0,
        pageSize: 20,
      },
      roundsLoading:false,
      listData:[],
      listLoading:false,
       examRoundList:[],
       schoolList:[],
       roundMark:null,
       markDetailModal:false,
       currentExamInfo: {},
       isEditMode: true,
       progressStatus: null
    }
  },
  created() {
    // 从URL中读取level参数
    const query = this.$route.query;
    if (query.level && /MATHS_TALENTS_\d/.test(query.level)) {
      this.filterForm.level = query.level;
    }
    this.getRelationList(this.filterForm)
    this.getRounds();
    this.getAllSchools();
  },
  methods: {
    goBack() {
      this.$router.push({
        name:'paperListTeacher'
      })
    },
    examProgress (row) {
      const nowTime = getSystemTimeSync();
      const costTimeInMs = (row.rule?.costTime || 0) * 60 * 1000;
      const endTime = row.startTime + costTimeInMs;
      let styles = {}
      if (nowTime < row.startTime) {
          styles =  {
          text: '未开始',
          class: 'not-started'
        };
      } else if (nowTime >= row.startTime && nowTime <= endTime) {
        styles =  {
          text: '进行中',
          class: 'in-progress'
        };
      } else {
        styles =  {
          text: '考试已结束',
          class: 'not-started'
        };
      }
      this.progressStatus = styles;
      return styles
    },
    // 重置查询条件
    handleReset() {
      this.filterForm = {
        level: this.filterForm.level,
        roundId: '',
        markModeStatus: ''
      };
      this.pagination.pageNo = 0;
      this.getRelationList(this.filterForm);
    },
    // 查询
    handleQuery() {
      this.pagination.pageNo = 0;
      this.getRelationList(this.filterForm);
    },
    // 查询所有学校
    getAllSchools() {
      getUserSchools().then(res => {
        if(res.code === 200 && res.body?.schools){
          this.schoolList = res.body?.schools;
        }
      })
    },
    // 查询所有考试
    getRounds(query='') {
      this.roundsLoading = true;
      getExamRounds({
        roundName:query,
        level:this.filterForm.level
      }).then(res => {
        if(res.code === 200 && res.body?.examRounds){
          this.examRoundList = res.body?.examRounds || [];
        }
      }).finally(() => {
        this.roundsLoading = false;
      })
    },
    // 获取考试批改规则详情
    markRelationDetail(id) {
      return new Promise((resolve, reject) => {
        getMarkRelationDetail(id,this.filterForm.level).then(res => {
          if(res.code === 200 && res.body?.roundMark) {
            this.roundMark = res.body?.roundMark || {};
            resolve(res);
          } else {
            reject(new Error(res.msg || '获取批改规则详情失败'));
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取列表数据
    getRelationList(params = {}) {
      this.listLoading = true;
      console.log(params,'params=====')
      getExamMarkRelationList({
        ...params,
        markMode: "CROSS",
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize,
      }).then(res => {
        this.listLoading = false;
        if(res.code === 200 && res.body?.rounds){
          this.listData = res.body?.rounds;
          this.pagination = {
            ...this.pagination,
            total: res.body?.totalCount,
          }
        }else {
          this.$message.error({
            message: res.message || '暂时没有需要配置规则的考试',
            offset: 300,
          });
        }
      }).catch(() => {
        this.listLoading = false;
      })
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNo = 0;
      this.getRelationList(this.filterForm);
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.getRelationList(this.filterForm);
    },
    // 计算了考试结束时间
    calculateEndTime(row) {
      const costTimeInMs = (row.rule?.costTime || 0) * 60 * 1000;
      const endTime = row.startTime + costTimeInMs;
      return dayjs(endTime).format('YYYY-MM-DD HH:mm:ss');
    },

     // 编辑/查看规则
     async handleEdit(row, action) {
      console.log(row,'======');
       try {
         this.isEditMode = action === 'edit';
         this.currentExamInfo = {
           roundName: row.roundName,
           startTime: row.startTime,
           progressStatus:this.examProgress(row),
         };
         await this.markRelationDetail(row.roundMark.id);
         if(this.roundMark) {
           this.markDetailModal = true;
         } else {
           this.$message.error('获取批改规则详情失败，请稍后重试');
         }
       } catch (error) {
         this.$message.error('获取批改规则详情失败，请稍后重试');
         console.error('获取批改规则详情失败:', error);
       }
     },
     // 关闭弹窗
     handleModalClose() {
       this.markDetailModal = false;
       this.isEditMode = false;
       this.currentExamInfo = {};
     },
     // 保存规则
     handleSaveRule() {
       // TODO: 调用保存接口
       this.$message.success('保存成功');
       this.handleReset();
       this.handleModalClose();
     },
     /**
     * 更新URL参数，同步tab和level到URL
     */
    updateUrlParams() {
      const query = {
        ...this.$route.query,
        level: this.filterForm.level
      };
      // 使用replace避免在浏览器历史中产生太多记录
      this.$router.replace({
        query
      }).catch((e) => {
        console.error('Failed to update URL params:', e);
        // 忽略导航重复的错误
      });
    },
  }
}
</script>


<style scoped lang="less">
  .paper-page-container{
    background: #EDE4DA;
    min-height: 100vh;
    padding: 72px 0 0;
    box-sizing: border-box;
    .page-content{
      max-width: 1400px;
      margin: 24px auto;
      border-radius: 12rpx;
      .page-content-head{
        background: #FFFFFF;
        padding: 0 40px;
        display: flex;
        align-items: center;
        flex-direction: column;
        height: 184px;
        border-radius: 12px 12px 0 0;
        .page-title-warp{
          position: relative;
          text-align: center;
          width: 100%;
          font-weight: 600;
          margin-top: 36px;
          .back{
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            font-size: 16px;
            cursor: pointer;
            color: #4E5969;
            i{
              color: #4E5969;
              margin-right: 8px;
            }
          }
          .title{
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            font-weight: 600;
            color: #000000;
            i{
              width: 30px;
              height: 30px;
              background: url("./images/check.png") no-repeat center center;
              background-size: cover;
              margin-right: 4px;
            }
          }
        }
        .filter-section {
          width: 100%;
          margin-top: 40px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          .filter-form {
            text-align: left;
            position: relative;
            margin-bottom: 24px;
            //width: 70%;
            .el-form-item {
              margin-bottom:0;
              margin-right: 28px;
              .el-input, .el-select {
                width: 120px;
                &.form-select-width{
                  width: 200px;
                }
                &.select-round{
                  width: 250px;
                }
              }
            }
          }
          .form-btns{
            display: flex;
            align-items: center;
            .el-button{
              height: 36px;
              line-height: 36px;
              text-align: center;
              border-radius: 90px;
              border: none;
              outline: none;
              font-size: 14px;
              font-weight: 500;
              padding: 0 24px;
              i {
                margin-right: 10px;
              }
              &.create-btn{
                background: #E60012;
                color: #FFFFFF;
              }
              &.createAll-btn{
                background: #F2F3F5;
                color: #000000;
              }
              &.search-btn{
                background: #E60012;
                color: #fff;
              }
              &.reset-btn{
                background: #F2F3F5;
                color: #000;
              }
            }
          }
          .action-buttons {
            display: flex;
            gap: 12px;
            margin-left: 24px;
            flex-wrap: wrap;

            .el-button {
              padding: 12px 24px;
              font-size: 16px;
              font-weight: 500;
              white-space: nowrap;
            }
          }
        }
      }
      .page-content-body{
        background: #F7F6F5;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding:20px 40px 40px;
        box-sizing: border-box;
        border-radius: 0 0 12px 12px;
        .page-tips{
          width: 100%;
          display: flex;
          align-items: center;
          color: #1D2129;
          font-weight: 500;
          font-size: 16px;
          span{
            height: 14px;
            width: 3px;
            background: #E60012;
            border-radius: 90px;
            margin-right: 8px;
          }
        }
        .table-section{
          width: 100%;
          background: #FFFFFF;
          border-radius: 8px;
          overflow: hidden;
          margin: 20px 0;
          .data-table {
            .el-table__header {
              background: #F7F8FA;
            }

            .el-table__header th {
              background: #F7F8FA;
              color: #1D2129;
              font-weight: 600;
              font-size: 14px;
              border-bottom: 1px solid #E5E6EB;
            }

            .el-table__body tr {
              &:hover {
                background: #F7F8FA;
              }
            }

            .el-table__body td {
              border-bottom: 1px solid #F2F3F5;
              padding: 16px 0;
            }
          }
        }
        .pagination-section {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          box-sizing: border-box;
          align-items: center;
          .pagination-info {
            font-size: 14px;
            color: #000;
            margin-right: 30px;
            font-weight: 500;
            span {
              margin: 0 4px;
            }
          }

          .pagination-controls {
            display: flex;
            align-items: center;

            .el-pagination {
              margin-right: 0;
              .el-pager li {
                background: none;
                &.active {
                  background: #E60012;
                  color: #fff;
                  border-color: #E60012;
                }
              }
            }

            .page-jump {
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #606266;

              span {
                margin: 0 4px;
              }
            }
          }
        }
        .back-btn{
          width: 240px;
          height: 48px;
          background: #E60012;
          border-radius: 24px;
          color: #fff;
          font-size: 18px;
          margin-top: 56px;
        }
        // 考试进度状态样式
        .progress-status {
          font-size: 13px;
          font-weight: 500;
          color: #7D8087;
          display: flex;
          align-items: center;
          justify-content: center;
          .status-dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            margin-right: 4px;
            display: inline-block;
          }

          &.not-started {
            .status-dot {
              background: #F53F3F;
            }
          }

          &.in-progress {
            .status-dot {
              background: #BD9F68;
            }
          }

          &.not-started {
            .status-dot {
              background: #D9D9D9;
            }
          }
        }

        // 规则确认状态样式
        .confirm-status {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;

          &.confirmed {
            color: #00B42A;
          }

          &.unconfirmed {
            color: #c9a96a;
          }
        }

        // 操作按钮样式
        .action-btn {
          color: #BD9F68;
          font-size: 14px;
          padding: 0;
          i{
            margin-right: 2px;
          }
          &:hover {
            color: #BD9F68;
          }
          &.disabled {
            color: #C9CDD4;
            cursor: no-drop;
          }
        }
      }
    }
  }
</style>
<style lang="less">
.paper-page-container{
  .el-form-item__label {
    font-size: 16px;
    font-weight: bold;
    padding: 0 4px 0 0;
    margin-right: 8px;
    color: #1D2129;
  }
  .el-input__inner, .el-select .el-input__inner {
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    width: 120px;
  }
  .select-round{
    width: 250px;
    .el-input__inner{
      width: 100%;
    }
  }
  .form-select-width{
    width: 220px;
    .el-input__inner{
      width: 100%;
    }
  }
  .el-input__inner{
    width: 100%;
  }
  .el-button {
    height: 32px;
    padding: 0 16px;
    border-radius: 4px;
  }
  .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{
    background-color: #FAFAFA !important;
  }
  .el-table {
    .el-table__header-wrapper {
      .el-table__header {
        thead{
          color: #000000;
          font-weight: 500;
          tr{
            background: #F7F1E6;
            th{
              background: #F7F1E6;
              border-bottom: none !important;
            }
          }
        }
        height: 60px;
      }
    }

    .el-table__body-wrapper {
      .el-table__body{
        .el-table__cell{
          padding: 10px 0;
          .roles-container {
            display: flex;
            align-items: center;
            gap: 8px;
            justify-content: center;
            flex-direction: column;
          }
        }
        tr{
          td{
            border-bottom: none !important;
          }
        }
      }
    }
  }

  .el-tag {
    border-radius: 12px;
    padding: 0 8px;
    height: 24px;
    line-height: 22px;
    font-size: 12px;
  }

  .el-pagination {
    button:disabled{
      background-color: transparent;
    }
    .el-pager li {
      min-width: 32px;
      height: 32px;
      font-size: 14px;
      color: #000;
      line-height: 30px;
      border-radius: 4px;
      margin: 0 2px;
      background: none;
      &.active{
        color: #E60012;
      }
    }
    .btn-prev, .btn-next {
      width: 32px;
      height: 32px;
      line-height: 30px;
      border-radius: 4px;
      background: none;

    }
  }
}
</style>